import GameScene from "../../scenes/GameScene";
import CyberShooter, { CyberShooterActions, CyberShooterStates } from "../../sprites/CyberShooter";
import DigitalWarrior from "../../sprites/DigitalWarrior";
import { AITargets } from "./DigitalWarriorAI";

export default class CyberShooterAI {
    scene: GameScene;
    opponent: CyberShooter;
    player: DigitalWarrior;
    currentAction: CyberShooterActions;
    currentState: CyberShooterStates;
    awayDirection: Phaser.Math.Vector2;
    currentTarget: AITargets;
    randomness = 50 * Math.random();


    constructor(scene: GameScene, opponent: CyberShooter, player: DigitalWarrior){
        this.scene = scene;
        this.opponent = opponent;
        this.player = player;
        this.reset();
    }

    tooClose(): boolean {
        return (
            this.closenessX(75+this.randomness,this.player) &&
            this.closenessY(75+this.randomness, this.player)
        )
    }

    closeEnough(): boolean {
        return (
            this.closenessX(275+this.randomness, this.player) &&
            this.closenessY(275+this.randomness, this.player)
        )
    }

    closenessX(dist: number, target: any){
        const xDiff = target.x - this.opponent.x;
        return (xDiff > -1 * dist && xDiff < dist);
    }

    closenessY(dist: number, target: any){
        const yDiff = target.y - this.opponent.y;
        return (yDiff > -1 * dist && yDiff < dist);
    }

    getCurrentTargetObject(){
        switch(this.currentTarget){
            case AITargets.PLAYER:
                return this.player;
            break;
            case AITargets.AWAY:
                return this.player;
            break;
        }
    }

    facingRightDirection(): boolean {
        const td = this.getTargetDirection();
        return (
            this.opponent.directionFacing.equals(td) ||
            this.opponent.directionFacing.y === td.y && td.x === 0 ||
            this.opponent.directionFacing.x === td.x && td.y === 0
        )
    }

    getTargetDirection(){
        const target = this.getCurrentTargetObject();
        const direction = new Phaser.Math.Vector2(0,0);
        if(target !== null){
            if(target.x > this.opponent.x)
                direction.x = 1;
            if(target.x < this.opponent.x)
                direction.x = -1;
            if(target.y > this.opponent.y)
                direction.y = 1;
            if(target.y < this.opponent.y)
                direction.y = -1;
        }
        if(this.currentTarget === AITargets.AWAY)
            direction.set(direction.x * -1, direction.y * -1);
        return direction;
    }

    reset(){
        this.currentTarget = AITargets.PLAYER;
        this.currentAction = CyberShooterActions.IDLE;
        this.currentState = CyberShooterStates.NORMAL;
        this.awayDirection = new Phaser.Math.Vector2(0,0);
    }

    update(time: number, delta: number){
        //if we're hit or dead you're not allowed to think.
        if(this.opponent.currentState === CyberShooterStates.HIT || this.opponent.currentState === CyberShooterStates.DEAD) return;
        switch(this.currentAction){
            case CyberShooterActions.IDLE:
                if(!this.closeEnough()){
                    this.currentAction = CyberShooterActions.MOVING;
                }else if(this.tooClose()){
                    this.currentTarget = AITargets.AWAY;
                    this.currentAction = CyberShooterActions.MOVING;
                }else if(this.opponent.currentAction !== CyberShooterActions.IDLE){
                    this.opponent.move(new Phaser.Math.Vector2(0,0));
                }else{
                    if(!this.facingRightDirection()){
                        this.currentAction = CyberShooterActions.MOVING;
                    }
                    if(this.opponent.canShoot()){
                        this.currentAction = CyberShooterActions.ATTACKING;
                    }
                }
            break;
            case CyberShooterActions.MOVING:
                const targetDir =  this.getTargetDirection();
                this.opponent.move(targetDir);
                if(this.closeEnough() && !this.tooClose()){
                    if(this.currentTarget === AITargets.AWAY) this.currentTarget = AITargets.PLAYER;
                    this.currentAction = CyberShooterActions.IDLE;
                }
            break;
            case CyberShooterActions.ATTACKING:
                if(this.opponent.canShoot()){
                    const angle = Phaser.Math.Angle.BetweenPoints(this.opponent,this.player);
                    this.opponent.fireDirection.set(Math.cos(angle),Math.sin(angle));
                    this.opponent.setAction(CyberShooterActions.ATTACKING);
                };
                this.currentAction = this.opponent.currentAction;
            break;
        }

    }

}